export const MEET_CHAT_IMAGE_TOPIC = 'meet-chat-image';
/** LiveKit ограничивает один data-пакет ~15 KB. */
export const CHAT_MESSAGE_CHUNK_SIZE = 14000;
export const fileToDataUrl = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ''));
    reader.onerror = () => reject(new Error('Не удалось прочитать изображение'));
    reader.readAsDataURL(file);
});
export const publishReliableChatData = (room, payload) => room.localParticipant.publishData(new TextEncoder().encode(payload), { reliable: true });
export const publishChunkedChatMessage = async (room, transferId, serializedMessage) => {
    const totalChunks = Math.ceil(serializedMessage.length / CHAT_MESSAGE_CHUNK_SIZE);
    await Promise.all(Array.from({ length: totalChunks }, (_, chunkIndex) => {
        const chunkEnvelope = {
            type: 'chat_message_chunk',
            transferId,
            chunkIndex,
            totalChunks,
            chunk: serializedMessage.slice(chunkIndex * CHAT_MESSAGE_CHUNK_SIZE, (chunkIndex + 1) * CHAT_MESSAGE_CHUNK_SIZE),
        };
        return publishReliableChatData(room, JSON.stringify(chunkEnvelope));
    }));
};
